export const LOCALIZATION_DICTIONARY = {
  EN: {
    LABEL: {
      READ: 'Read',
      GO_TO_BOOKMARK: 'Go To Bookmark',
      HIGHLIGHT: 'Highlight',
      COPY: 'Copy',
      ADD_NOTE: 'Add Note',
      UNIT: 'Unit',
      ALL_SOUNDS: 'All Sounds',
      LISTEN: 'Listen',
      NEW_BOOKMARK: 'New Bookmark',
      NOTE: 'Note',
      SAVE: 'Save',
      DELETE: 'Delete',
      HIGHLIGHT_COLOR: 'Highlight Color',
      GO_BACK: 'Go back',
      TOC: 'Table of contents',
      CLOSE_TOC: 'Close table of contents',
      BOOKMARK: 'Bookmark',
      PLAY: 'Play',
      MUTE: 'Mute',
      UNMUTE: 'Unmute',
      SPEED: 'Reading speed',
      RESET: 'Reset',
      PREVIOUS_PAGE: 'Previous page',
      NEXT_PAGE: 'Next page',
      ZOOM_IN: 'Zoom in',
      ZOOM_OUT: 'Zoom out',
      DELETE_BOOKMARK: 'Delete bookmark',
      EDIT_BOOKMARK: 'Edit bookmark',
      WALKTHROUGH: 'Amplify Hub walkthrough',
      SOUND_TABS: 'Sounds grouped by units',
      EBOOK_TABS: 'Books grouped by readers',
    },
    MESSAGE: {
      LOADING: 'Loading...',
      OPENING: 'Book is opening...',
      DELETE_CONFIRM: 'Are you sure you want to delete your bookmark?',
      DELETE_CONFIRM_YES: 'Yes, delete it!',
      DELETE_CONFIRM_NO: 'No',
      BOOKMARK_CONFIRM:
        'By placing your bookmark here, you will lose your previously marked page. Do you still want to add a new bookmark here?',
      BOOKMARK_CONFIRM_YES: 'Yes, add a new bookmark! ',
      BOOKMARK_CONFIRM_NO: 'No, keep my old bookmark.',
    },
    READING_SPEED_OPTIONS: {
      SLOWER: 'Slower',
      MEDIUM: 'Medium',
      FASTER: 'Faster',
    },
  },
  ES: {
    LABEL: {
      READ: 'Leer',
      GO_TO_BOOKMARK: 'Ir al marcador',
      HIGHLIGHT: 'Resaltar',
      COPY: 'Copiar',
      ADD_NOTE: 'Agregar nota',
      UNIT: 'Unidad',
      ALL_SOUNDS: 'Todos los sonidos',
      LISTEN: 'Escucha',
      NEW_BOOKMARK: 'Nuevo marcador',
      NOTE: 'Nota',
      SAVE: 'Guardar',
      DELETE: 'Borrar',
      HIGHLIGHT_COLOR: 'Color de resalte',
      GO_BACK: 'Regresar',
      TOC: 'Tabla de contenido',
      CLOSE_TOC: 'Cerrar tabla de contenido',
      BOOKMARK: 'Añadir el marcador',
      PLAY: 'Reproducir',
      MUTE: 'Silencio',
      UNMUTE: 'Sonido',
      SPEED: 'Velocidad de lectura',
      RESET: 'Reiniciar',
      PREVIOUS_PAGE: 'Página anterior',
      NEXT_PAGE: 'Página siguiente',
      ZOOM_IN: 'Acercar',
      ZOOM_OUT: 'Alejar',
      DELETE_BOOKMARK: 'Eliminar marcador',
      EDIT_BOOKMARK: 'Editar marcador',
      WALKTHROUGH: 'Guía paso a paso de Amplify Hub',
      SOUND_TABS: 'Sonidos agrupados por unidades',
      EBOOK_TABS: 'Libros agrupados por lectores',
    },
    MESSAGE: {
      LOADING: 'Cargando...',
      OPENING: 'El libro se está abriendo...',
      DELETE_CONFIRM: '¿Confirmas que deseas borrar el marcador?',
      DELETE_CONFIRM_YES: 'Sí, deseo borrarlo.',
      DELETE_CONFIRM_NO: 'No.',
      BOOKMARK_CONFIRM:
        'Si agregas un marcador aquí, perderás la página que marcaste anteriormente. ¿Confirmas que deseas agregar un nuevo marcador aquí?',
      BOOKMARK_CONFIRM_YES: 'Sí, deseo agregar un nuevo marcador.',
      BOOKMARK_CONFIRM_NO: 'No, deseo conservar el marcador anterior.',
    },
    READING_SPEED_OPTIONS: {
      SLOWER: 'Lenta',
      MEDIUM: 'Media',
      FASTER: 'Rápida',
    },
  },
}
